import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.match";
import { KEY } from './Services';
export var getIsActive = function getIsActive(key) {
  return window.location.hostname.includes(key);
};
export var postfix = '-xyz.com';
/**
 * проверяем stage
 */

export var getPrefix = function getPrefix() {
  var currentHostname = window.location.hostname;
  var keysReg = Object.keys(KEY).reduce(function (prev, cur) {
    return "".concat(prev ? "".concat(prev, "|") : '').concat(cur);
  }, '');
  var currentReg = new RegExp("(".concat(keysReg, ")").concat(postfix));
  var match = currentHostname.match(currentReg);
  var prefix = match ? currentHostname.slice(0, match.index) : '';

  if (['stage.'].includes(prefix)) {
    return prefix;
  }

  return '';
};
export var getWithLang = function getWithLang(key, hostname, currentLang) {
  var prefix = getPrefix();

  if (key === KEY.school) {
    if (prefix) {
      return "".concat(prefix).concat(hostname);
    }

    if (currentLang === 'en') {
      return "en.".concat(hostname);
    }

    return "".concat(hostname);
  }

  if (key === KEY.media) {
    return "".concat(prefix).concat(hostname, "/ru");
  }

  return "".concat(prefix).concat(hostname, "/").concat(currentLang);
};
export var getServiceUrl = function getServiceUrl(key, currentLang) {
  var targetHostname = "".concat(key).concat(postfix);
  return "https://".concat(getWithLang(key, targetHostname, currentLang));
};